import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import subscriberSuccessfulImage from "@assets/images/subscriber_successful.png";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { Primary } from "@ui/components/containers/primary";
import { row } from "@ui/components/layout";
import { ClosableModal } from "@ui/modals/closableModal";
interface SubscriptionSuccessModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}

export const SubscriptionSuccess: React.FC<SubscriptionSuccessModalProps> = ({ close, ...htmlProps }) => {
	return (
		<Container close={close} {...htmlProps}>
			<ContainerLabel>
				<img src={subscriberSuccessfulImage} width="100px" height="100px" />
				<Primary>
					<StuledLabelText>
						<b>{I18n.t("shareroom.subscription.success.title")}</b>
					</StuledLabelText>
				</Primary>
			</ContainerLabel>
			<Info>{I18n.t("shareroom.subscription.success.description")}</Info>
			<BlocButton>
				<StyledButtonContainer onClick={() => close()}>{I18n.t("ok")}</StyledButtonContainer>
			</BlocButton>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const ContainerLabel = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

const Info = styled.div`
	${row(16, "flex-start", "baseline")};
	${({ theme }) => theme.textStyles.description};
	font-style: normal;
	font-weight: 400;
	font-size: 15px;
	line-height: 30px;
	text-align: center;
	color: #000000;
	margin-top: 30px;
`;

const StuledLabelText = styled.div`
	font-style: normal;
	font-size: 24px;
	margin-top: 16px;
`;
const BlocButton = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
`;
const StyledButtonContainer = styled(PrimaryButton)``;
